import jQuery from "jquery";

const $ = jQuery;

const pageSubNav = (($) => { // eslint-disable-line

  const me = {};

  // let    wScrollBefore = 0;

  // const makeSticky = () => {

  //     const $body                 = $('body');
  //     const $pageSubNav             = $('.page-sub-nav');
  //     const $pageHeader             = $('.page-header');
  //     const $notifications        = $('.notification-bar');
  //     const pageHeaderHeight         = $pageHeader.outerHeight();
  //     const notificationHeight     = $notifications.outerHeight();
  //     const $scrollContent        = $(window);
  //     let    elIsSticky                = false;
  //     const elHeight                = $pageSubNav.outerHeight();
  //     const dHeight                = $('body').height();
  //     const wHeight                = $(window).height();
  //     const wScrollCurrent        = $scrollContent.scrollTop();
  //     const wScrollDiff            = wScrollBefore - wScrollCurrent;
  //     const elTop                    = parseInt($pageSubNav.css('top'), 10) + wScrollDiff;
  //     let subNavsTopPosition;

  //     $pageSubNav.css('opacity', 1);

  //     // If notifications exist theyre height should be included
  //     if ($notifications.length && $notifications.offset().top < $pageHeader.offset().top) {

  //         if ($(window).width() > 1199) {

  //             subNavsTopPosition = (pageHeaderHeight + notificationHeight) - (elHeight / 2);

  //         } else {

  //             subNavsTopPosition = pageHeaderHeight + notificationHeight;

  //         }

  //     } else {

  //         if ($(window).width() > 1199) {

  //             subNavsTopPosition = $pageHeader.outerHeight() - ($pageSubNav.outerHeight() / 2);

  //         } else {

  //             subNavsTopPosition = $pageHeader.outerHeight();

  //         }

  //     }

  //     const triggerPosition = subNavsTopPosition;

  //     if (wScrollCurrent >= triggerPosition) {

  //         elIsSticky = true;

  //     } else {

  //         elIsSticky = false;

  //     }

  //     if (elIsSticky && parseInt($pageSubNav.css('top'), 10) === -elHeight) {

  //         $pageSubNav.addClass('is-fullwidth');

  //     }

  //     if (elIsSticky) {
  //         $pageSubNav.addClass('is-sticky');
  //         $body.addClass('has-sticky-nav');

  //         // Scroll upp
  //         if (wScrollDiff > 0) {

  //             $pageSubNav.css('top', elTop > 0 ? '' : elTop);

  //         // Down scroll

  //         } else if (wScrollDiff < 0) {

  //             // Scrolled to bottom of page
  //             if (wScrollCurrent + wHeight >= dHeight - elHeight) {

  //                 $pageSubNav.css('top', (elTop === wScrollCurrent + wHeight - dHeight) < 0 ? elTop : 0);

  //             // Down scroll

  //             } else {

  //                 $pageSubNav.css('top', Math.abs(elTop) > elHeight ? -elHeight : elTop);

  //             }

  //         }

  //         wScrollBefore = wScrollCurrent;

  //     } else {

  //         $pageSubNav.removeClass('is-sticky is-fullwidth');

  //         if ($(window).width() > 1199) {

  //             $pageSubNav.css('top', subNavsTopPosition);

  //         } else {

  //             $pageSubNav.css('top', '');

  //         }

  //         $body.removeClass('has-sticky-nav');

  //     }

  // };

  // const showHideApplyButton = () => {

  //     const scrollPosition                = $(window).scrollTop();
  //     const $pageSubNav                    = $('.page-sub-nav');
  //     const $navApplyButton                 = $('.page-sub-nav .apply-link');
  //     const $hero                         = $('.card-hero-section');
  //     const $heroApplyButton                 = $('.card-hero-section .apply-link');
  //     const buttonHeight                     = $heroApplyButton.outerHeight();

  //     if ($navApplyButton.length) {

  //         // Detect how much of page-sub-nav
  //         // is visible in DOM (when its sticky)
  //         const pageSubNavAdjustment             = parseInt($pageSubNav.css('top').replace('px', ''), 10);

  //         // The spacing between apply-button and page-sub-nav
  //         const navApplyButtonDistanceFromNav = parseInt($navApplyButton.css('top').replace('px', ''), 10);

  //         if ($hero.length && $(window).outerWidth() < 768) {

  //             const heroApplyButtonPosition = $heroApplyButton.offset().top;

  //             // Calculate nav-apply buttons position based on
  //             // its distance from window top on scroll
  //             // because a fixed elements top position
  //             // does not update on scroll in Safari in iOS
  //             const navApplyButtonPosition = (scrollPosition + navApplyButtonDistanceFromNav + buttonHeight) + pageSubNavAdjustment;

  //             $navApplyButton.css('opacity', 0);

  //             if (navApplyButtonPosition >= heroApplyButtonPosition) {

  //                 $navApplyButton.css('opacity', 1);
  //                 $heroApplyButton.css('opacity', 0);

  //             } else {

  //                 $navApplyButton.css('opacity', 0);
  //                 $heroApplyButton.css('opacity', 1);

  //             }

  //         } else {

  //             $navApplyButton.css('opacity', 1);
  //             $heroApplyButton.css('opacity', 1);

  //         }

  //     }

  // };

  me.init = function() {

    // // Making sure everything is loaded
    // // is unfortunately needed to get
    // // the correct height of elements in safari
    // $(window).on('load', () => {

    //     showHideApplyButton();
    //     makeSticky();

    // });

    // if (!$('.alertbar').length) {
    //     $(window).on('scroll resize', () => {
    //         showHideApplyButton();
    //         makeSticky();
    //     });
    // }

  };

  return me;

})(jQuery); // eslint-disable-line

export default pageSubNav;
